(function () {
    'use strict';

    angular.module('app.promotionalImages', [
        'app.core',
        'app.widgets'
    ]);
})();
